module.exports = __webpack_public_path__ + "static/img/y_szyx.6284445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_szyx.png
// module id = 8R3G
// module chunks = 73